/* Lightweight, reusable entrance motion for non-homepage surfaces.
   Groups opt in with [data-entrance]; direct items use [data-entrance-item].
   The homepage keeps its separate GSAP scroll-fx orchestration. */
(function () {
  'use strict';

  var existing = window.ThroneEntranceFx;
  if (existing) {
    existing.init(document);
    return;
  }

  var GROUP_SELECTOR = '[data-entrance]';
  var ITEM_SELECTOR = '[data-entrance-item]';
  var ENTERED_CLASS = 'is-entered';
  var READY_CLASS = 'is-entrance-ready';
  var TRIGGER_POINT = 0.55;
  var groups = new Set();
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileLayout = window.matchMedia('(max-width: 899px)');
  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(onIntersection, {
        rootMargin: '0px 0px -45% 0px',
        threshold: 0
      })
    : null;

  function directItems(group) {
    return Array.prototype.filter.call(group.querySelectorAll(ITEM_SELECTOR), function (item) {
      return item.closest(GROUP_SELECTOR) === group;
    });
  }

  function reveal(group) {
    if (!group) return;
    group.classList.add(ENTERED_CLASS);
    if (observer) observer.unobserve(group);
  }

  function onIntersection(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      window.requestAnimationFrame(function () {
        reveal(entry.target);
      });
    });
  }

  function prepare(group) {
    if (groups.has(group)) return;
    groups.add(group);

    directItems(group).forEach(function (item, index) {
      item.style.setProperty('--entrance-order', index);
    });

    var staticMode = mobileLayout.matches
      || reduceMotion.matches
      || (window.Shopify && window.Shopify.designMode)
      || !observer;
    var alreadyReached = group.getBoundingClientRect().top <= window.innerHeight * TRIGGER_POINT;
    var animateOnLoad = group.hasAttribute('data-entrance-load');

    if (staticMode || (alreadyReached && !animateOnLoad)) {
      reveal(group);
      return;
    }

    group.classList.add(READY_CLASS);

    if (animateOnLoad && alreadyReached) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { reveal(group); });
      });
      return;
    }

    observer.observe(group);
  }

  function findGroups(root) {
    var matches = [];
    if (root instanceof Element && root.matches(GROUP_SELECTOR)) matches.push(root);
    return matches.concat(Array.prototype.slice.call(root.querySelectorAll(GROUP_SELECTOR)));
  }

  function init(root) {
    findGroups(root || document).forEach(prepare);
  }

  function destroy(root) {
    findGroups(root || document).forEach(function (group) {
      if (observer) observer.unobserve(group);
      directItems(group).forEach(function (item) {
        item.style.removeProperty('--entrance-order');
      });
      group.classList.remove(READY_CLASS, ENTERED_CLASS);
      groups.delete(group);
    });
  }

  function showAllIfStatic() {
    if (!reduceMotion.matches && !mobileLayout.matches) return;
    groups.forEach(reveal);
  }

  window.ThroneEntranceFx = { init: init, destroy: destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  if (reduceMotion.addEventListener) {
    reduceMotion.addEventListener('change', showAllIfStatic);
    mobileLayout.addEventListener('change', showAllIfStatic);
  } else {
    reduceMotion.addListener(showAllIfStatic);
    mobileLayout.addListener(showAllIfStatic);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
})();
